import {
  Box,
  CircularProgress,
  Grid,
  Hidden,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { OrangeButton } from 'components/Button';
import ModalPAC from 'components/ModalPAC';
import MyContractInfo from 'components/MyContractInfo/AMCContractInfo';
import MyPersonalInfo from 'components/MyContractInfo/AMCPersonalInfo';
import MyContractsTabs from 'components/MyContractsTabs';
import { ShortBody } from 'components/Typography';
import { ADHESION_DOCUMENT_TYPES } from 'constants/globalConstants';
import { PACProcess } from 'containers/AMCDashboard/PACProcess';
import KnowMoreAboutContract from 'containers/AmcDetailsPage/MyContractAndGarantiesTab/KnowMoreAboutContracts';
import messages from 'containers/AmcDetailsPage/MyContractAndGarantiesTab/MyHealthCoverage/messages';
import {
  ItemWrapper,
  SizedGridItem,
  StyledCaptions,
} from 'containers/AutoDetailsPage/MyContractsBloc/DownloadFileAutoContracts/styles';
import { downloadFile } from 'helpers/fileUtils';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import { isReverse, translate } from 'helpers/intl';
import usePolicy from 'hooks/policies/usePolicy';
import useDownloadPdf from 'hooks/sinister/useDownloadPdf';
import { AssuranceIcon } from 'images';
import { get, isEmpty } from 'lodash';
import { sanlamVeryDarkBlue } from 'Material-UI/colors';
import React, { useEffect } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PAGES from 'routes/pages';
import { getContractAMCDetails, getContractsAMC } from 'store/contract/actions';
import { getContractAMCDetailsSelector } from 'store/contract/selectors';
import {
  closeModalPAC,
  openModalPAC,
  setAMCDetailsPageBreadcrumbsPath,
} from 'store/global/actions';
import { getIsModalCreatePAC } from 'store/global/selectors';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { apiOrganismesPAC } from 'store/pac/apis';
import { StoreContext } from 'utils/contextStore';
import { SizedSmallSectionHeader } from '../FollowUpMyRequestsTab/styles';
import MyBeneficiaries from './MyBeneficiaries';
import { StyledGrid } from './styles';
import { PdfsPrestations } from './utils';

const TabItems = (
  contracts: any,
  reverse: boolean,
  organismeListPac: any[],
  props: any,
) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const [error, setError] = React.useState('');
  const {
    data: policy,
    get: searchPolicy,
    loading: policyLoading,
  } = usePolicy();

  const { get: downloadPdf, loading } = useDownloadPdf();

  const downloadAdhesionCertificate = /* istanbul ignore next */ (
    id: string,
  ) => {
    const {
      numeroPolice,
      codeSouscripteur,
      adhesionIdentifier,
      numSomme,
      PolicyIdentifier,
    } = props.contractAMCDetails;
    downloadPdf({
      payload: {
        type: ADHESION_DOCUMENT_TYPES.CA,
        numeroPolicy: numeroPolice,
        adhesionNumber: numSomme || id,
        codeSouscripteur: codeSouscripteur,
        adhesionIdentifier: adhesionIdentifier || id,
        policyIdentifier: PolicyIdentifier,
      },
      onSuccess: (content: string) =>
        downloadFile(content, `${numeroPolice}_ca.pdf`),
      onError: setError,
    });
  };

  const { numeroPolice = '' } = props.contractAMCDetails;

  useEffect(() => {
    if (numeroPolice) searchPolicy({ params: { reference: numeroPolice } });
  }, [numeroPolice]);

  /* istanbul ignore next */
  const getPdfUri = (c: any) =>
    PdfsPrestations.find((pdf) => pdf.policyNumber === get(c, 'NUM_POLICE', ''))
      ?.pdfUri;

  return props.contracts.map((c: any) => {
    /* istanbul ignore next */
    return {
      label: get(c, 'NUM_POLICE', ''),
      content: (
        <>
          <Grid style={{ marginBottom: 16, marginTop: 24 }} xs={12} item>
            <SizedSmallSectionHeader color={sanlamVeryDarkBlue} weight="bold">
              {props.intl.formatMessage({
                id: 'my_account.my_adherant_info',
              })}
            </SizedSmallSectionHeader>
          </Grid>
          <Grid style={{ marginBottom: 16, marginTop: 24 }} xs={12} item>
            <MyContractInfo
              souscripteur={get(c, 'NOM_SOUSCRIPTEUR', '')}
              identification={get(c, 'CIN', '')}
              name={get(contracts, 'member', '')}
            />
          </Grid>

          <Grid style={{ marginTop: 24 }} item xs={12}>
            <MyBeneficiaries
              organismeListPac={organismeListPac}
              selectedContract={contracts}
              beneficiaries={props.beneficiaries}
              openModalPAC={props.openModalPAC}
            />
          </Grid>

          {!isEmpty(
            organismeListPac?.find(
              /* istanbul ignore next */ (organisme) =>
                organisme?.NUM_POLICE === contracts?.numeroPolice,
            ),
          ) &&
            organismeListPac?.find(
              /* istanbul ignore next */ (organisme) =>
                organisme?.NUM_POLICE === contracts?.numeroPolice,
            ).NATURE_POLICE !== 'CNSS' &&
            organismeListPac?.find(
              /* istanbul ignore next */ (organisme) =>
                organisme?.NUM_POLICE === contracts?.numeroPolice,
            ).NATURE_POLICE !== 'DIM' &&
            contracts?.etatAdh !== 'RD' && (
              <Grid
                style={{
                  marginTop: 24,
                  flexDirection: 'row',
                  backgroundColor: '#F4F4F4',
                  padding: '28px',
                  borderRadius: '9px',
                }}
                justify="space-between"
                container
                xs={12}
              >
                <Grid item xs={12} sm={5}>
                  <SizedSmallSectionHeader
                    color={sanlamVeryDarkBlue}
                    weight="bold"
                  >
                    {translate({ ...messages.suiviPac }, props)}
                  </SizedSmallSectionHeader>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={5}
                  style={{ marginTop: isMobile ? '4px' : '0px' }}
                >
                  <Box>
                    <OrangeButton
                      style={{ justifyContent: 'space-between' }}
                      variant="contained"
                      onClick={
                        /* istanbul ignore next */ () =>
                          props.setAMCDetailsPageBreadcrumbsPath([
                            { name: 'amc', route: PAGES.AMC_DASHBOARD },
                            { name: 'suiviPAC' },
                          ])
                      }
                    >
                      <img
                        style={{ marginRight: '12px' }}
                        src={AssuranceIcon.SuiviPac}
                        alt=""
                      />
                      {translate({ ...messages.suiviPacShort }, props)}
                      <ChevronRightIcon />
                    </OrangeButton>
                  </Box>
                </Grid>
              </Grid>
            )}

          <Grid style={{ marginBottom: 16, marginTop: 24 }} xs={12} item>
            <SizedSmallSectionHeader color={sanlamVeryDarkBlue} weight="bold">
              {props.intl.formatMessage({
                id: 'my_account.my_personal_info',
              })}
            </SizedSmallSectionHeader>
          </Grid>

          <MyPersonalInfo
            regulationMode={get(contracts, 'modeReglement', '')}
            rib={get(contracts, 'rib', '')}
            adresse={get(contracts, 'adresse', '')}
          />

          {(getPdfUri(c) || props.contractAMCDetails?.hasCA) && (
            <Grid style={{ marginTop: 24 }} item xs={12}>
              <Grid container>
                <Grid xs={12} item>
                  <SizedSmallSectionHeader
                    color={sanlamVeryDarkBlue}
                    weight="bold"
                  >
                    {props.intl.formatMessage({
                      id: 'auto_details_page.document_download_title',
                    })}
                  </SizedSmallSectionHeader>
                </Grid>

                {getPdfUri(c) && (
                  <SizedGridItem item>
                    <ItemWrapper
                      style={{ marginRight: 0, marginLeft: 0 }}
                      data-testid={`download-file-${1}`}
                      onClick={
                        /* istanbul ignore next */ () =>
                          global.open(getPdfUri(c))
                      }
                    >
                      <img
                        alt="downloadIcon"
                        src={AssuranceIcon['downloadIcon']}
                      />
                      <StyledCaptions reverse={reverse}>
                        {props.intl.formatMessage({
                          id: 'amc.details.details.prestations',
                        })}
                      </StyledCaptions>
                    </ItemWrapper>
                  </SizedGridItem>
                )}
                {props.contractAMCDetails?.hasCA && (
                  <>
                    <StyledGrid item>
                      <ItemWrapper
                        style={{ marginRight: 0, marginLeft: 0 }}
                        data-testid={`download-file-${1}`}
                        onClick={() => {
                          if (loading || policyLoading) {
                            return;
                          }
                          setError('');
                          downloadAdhesionCertificate(policy.id);
                        }}
                      >
                        {loading ? (
                          <Grid item>
                            <CircularProgress size={15} color="secondary" />
                          </Grid>
                        ) : (
                          <img
                            alt="downloadIcon"
                            src={AssuranceIcon['downloadIcon']}
                          />
                        )}
                        <StyledCaptions reverse={reverse}>
                          {props.intl.formatMessage({
                            id: 'amc.details.details.ca',
                          })}
                        </StyledCaptions>
                      </ItemWrapper>
                    </StyledGrid>
                  </>
                )}
              </Grid>
              {error && (
                <ShortBody color="red">
                  {props.intl.formatMessage({
                    id: error,
                  })}
                </ShortBody>
              )}
            </Grid>
          )}
        </>
      ),
      contractNumber: 'string',
      circulationDate: 'string',
    };
  });
};

const MyContractAndGarantiesTab = (props: {
  intl: IntlShape;
  contractAMCDetails: any;
  contracts: any;
  beneficiaries: any;
  getContractAMCDetails: any;
  selectedPolice?: string;
  openModalPAC: Function;
  closeModalPAC: Function;
  setAMCDetailsPageBreadcrumbsPath: Function;
  isOpenModalPAC: boolean;
}) => {
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);

  const { organismeListPacState } = React.useContext(StoreContext);

  const setOrganismeListPac = organismeListPacState?.setOrganismeListPac;
  const organismeListPac = organismeListPacState?.organismeListPac;

  React.useEffect(() => {
    const token = localStorage.getItem('token');

    apiOrganismesPAC({ token })
      .then((result) => {
        const pacOrganisme: any[] = [];
        /* istanbul ignore next */
        if (result.data.data.length > 0) {
          props.contracts.map(
            /* istanbul ignore next */ (c: any) => {
              const organisme = result.data.data.find(
                /* istanbul ignore next */ (r: any) =>
                  r.NUM_POLICE === c.NUM_POLICE,
              );
              organisme && pacOrganisme.push(organisme);
              return null;
            },
          );
        }
        /* istanbul ignore next */
        setOrganismeListPac(pacOrganisme);
      })
      .catch((error) => {});
  }, []);
  /* istanbul ignore next */
  React.useEffect(() => {
    /* istanbul ignore next */
    if (!isEmpty(props.contracts)) {
      /* istanbul ignore next */
      const policyNumbers = props.contracts.map(
        (contract: { NUM_POLICE: string }) => contract.NUM_POLICE,
      );
      /* istanbul ignore next */
      props.getContractAMCDetails({
        language: lang,
        policyNumbers,
      });
    }
  }, [props.contracts]);
  /* istanbul ignore next */
  return (
    <>
      <GaLoadHOC
        category={EVENT_CATEGORIES.AMC_DETAILS}
        label="Mes contrats_Tab 2_Mes contrats"
      >
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Hidden xsDown>
              <KnowMoreAboutContract />
            </Hidden>
            <MyContractsTabs
              tabItems={TabItems(
                props.contractAMCDetails,
                reverse,
                organismeListPac,
                props,
              )}
              getDetailContract={props.getContractAMCDetails}
              isLoadingDetailContract={false}
              selectedPolice={props.selectedPolice}
              category=""
              label=""
            />
          </Grid>
        </Grid>
      </GaLoadHOC>
      <ModalPAC
        closeModalPAC={closeModalPAC}
        isOpen={props.isOpenModalPAC}
        content={<PACProcess />}
      />
    </>
  );
};
/* istanbul ignore next */
const mapStateToProps = createStructuredSelector<
  any,
  { contractAMCDetails: {}; isOpenModalPAC: boolean }
>({
  contractAMCDetails: getContractAMCDetailsSelector,
  isOpenModalPAC: getIsModalCreatePAC,
});
/* istanbul ignore next */
const mapDispatchToProps = {
  getContractAMCDetails,
  getContractsAMC,
  openModalPAC,
  closeModalPAC,
  setAMCDetailsPageBreadcrumbsPath,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(MyContractAndGarantiesTab));
